import images from "../../../assets";

const LoginLayout = ({ children }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <div className="w-full lg:h-screen h-full flex items-center justify-center relative">
        <video
          className="w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
          src={images.loginVideo}
        />
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(8px)",
          }}
        />
      </div>

      <div className="flex justify-center lg:justify-end p-10">
        <div className="absolute top-0 bottom-0 z-10 min-w-[300px] h-max lg:max-h-screen max-h-[90vh] overflow-y-auto lg:my-auto my-[80px] mx-4 lg:mx-0 px-6 lg:px-8 py-12 rounded-2xl bg-regCard backdrop-blur-md">
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default LoginLayout;
